import { ToastEventPayload } from '~/hooks/toast/useToastAlerts'
import {
  NotificationDomain,
  NotificationPayload,
} from '~/services/EventEmitter/types/NotificationEmitterTypes'

export enum ContactsOperation {
  ContactNumberCopiedToClipboard = 'contactNumberCopiedToClipboard',
}

const getContactNumberCopiedToClipboardEvent = (
  payload: NotificationPayload<NotificationDomain.CONTACTS>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'success':
      title = 'Phone number copied to clipboard'
      break
    case 'error':
      title = 'Unable to copy phone number'
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

export const getContactsToastEvent = (
  payload: NotificationPayload<NotificationDomain.CONTACTS>,
) => {
  switch (payload.operation) {
    case ContactsOperation.ContactNumberCopiedToClipboard:
      return getContactNumberCopiedToClipboardEvent(payload)
    default:
      return null
  }
}
